import {UserModule} from '@/store/modules/user'
import {ObjectDirective} from "vue/types/v3-directive";

export const account: ObjectDirective = {
    inserted(el, binding) {
        const {value} = binding
        const accounts = UserModule.accountType
        if (value && value instanceof Array && value.length > 0) {
            const allowAccounts = value
            const hasPermission = accounts.some(a => {
                return allowAccounts.includes(a)
            })
            if (!hasPermission) {
                el.style.display = 'none'
            }
        } else {
            throw new Error('need accountType! Like v-account="[\'A\',\'B\']"')
        }
    }
}

export const checkAccount = (allowAccounts: string[]): boolean => {
    const accounts = UserModule.accountType
    if (allowAccounts && allowAccounts.length > 0) {
        return accounts.some(a => {
            return allowAccounts.includes(a)
        })
    } else {
        throw new Error('need accountType! Like v-account="[\'A\',\'B\']"')
    }
}
